import React, { useContext, useEffect, useState } from "react";
import StudentForm from "./StudentForm";
import ManageApplication from "./ManageApplication";
import { AppContext } from "../context/AppContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import UploadChallan from "./UploadChallan";
import AllStudents from "../AdminSide/AllStudents";

const AllTabs = () => {
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("admission-form");
  const { loginUserEmail, setLoginUserEmail, studentInfo, setStudentInfo } =
    useContext(AppContext);

  useEffect(() => {
    if (loginUserEmail) {
      // Get the Bearer token (example using localStorage)
      const token = localStorage.getItem("token"); // Or from context: const { token } = useContext(AppContext);

      if (!token) {
        console.error("Authorization token missing.");
        return; // Stop if token is not found
      }

      axios
        .get(
          `${process.env.REACT_APP_API_URL}/students/student-info?email=${loginUserEmail}`,
          {
            headers: {
              Authorization: `Bearer ${token}`, // Include Bearer token
            },
          }
        )
        .then((response) => {
          setStudentInfo(response.data); // Set student info state
        })
        .catch((error) => {
          console.error("Error fetching student info:", error);
        });
    }
  }, [loginUserEmail, setStudentInfo]);

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar - Fixed */}
      <div className="w-64 p-6 fixed h-full text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
        <h2 className="text-md font-bold mb-6">NIIT Student Dashboard</h2>
        <nav className="space-y-3">
          <button
            className={`flex items-center w-full text-left p-3 rounded ${
              activeTab === "admission-form"
                ? "bg-blue-600 text-white"
                : "hover:bg-blue-700 hover:text-white"
            }`}
            onClick={() => setActiveTab("admission-form")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z"
                clipRule="evenodd"
              />
            </svg>
            Admission Form
          </button>
          <button
            className={`flex items-center w-full text-left p-3 rounded ${
              activeTab === "manage-application"
                ? "bg-blue-600 text-white"
                : "hover:bg-blue-700 hover:text-white"
            }`}
            onClick={() => setActiveTab("manage-application")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
              <path
                fillRule="evenodd"
                d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z"
                clipRule="evenodd"
              />
            </svg>
            Manage Application
          </button>
          <button
            className={`flex items-center w-full text-left p-3 rounded ${
              activeTab === "upload-chalan"
                ? "bg-blue-600 text-white"
                : "hover:bg-blue-700 hover:text-white"
            }`}
            onClick={() => setActiveTab("upload-chalan")}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M3 17a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM6.293 6.707a1 1 0 010-1.414l3-3a1 1 0 011.414 0l3 3a1 1 0 01-1.414 1.414L11 5.414V13a1 1 0 11-2 0V5.414L7.707 6.707a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
            Upload Fee Chalan
          </button>
          <button
            className="flex items-center w-full text-left p-3 rounded text-red-500 hover:bg-red-600 hover:text-white"
            onClick={() => {
              localStorage.clear(); // Clears all items in localStorage, or you can use removeItem("key") if you want to remove a specific item
              navigate("/");
              setLoginUserEmail(null);
              setStudentInfo(null);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-2"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M3 3a1 1 0 00-1 1v12a1 1 0 102 0V4a1 1 0 00-1-1zm10.293 9.293a1 1 0 001.414 1.414l3-3a1 1 0 000-1.414l-3-3a1 1 0 10-1.414 1.414L14.586 9H7a1 1 0 100 2h7.586l-1.293 1.293z"
                clipRule="evenodd"
              />
            </svg>
            Logout
          </button>
        </nav>
      </div>

      {/* Main Content - Full-Screen Scroll */}
      <div className="flex-1 ml-64 overflow-y-auto">
        <div className="max-w-7xl mx-auto p-8 bg-white shadow-lg rounded-lg min-h-screen">
          {/* Admission Form */}
          {activeTab === "admission-form" && <StudentForm />}

          {/* Manage Application */}
          {activeTab === "manage-application" && <ManageApplication />}

          {/* Upload Chalan */}
          {activeTab === "upload-chalan" && (
            <div>
              <UploadChallan />
              {/* <AllStudents /> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AllTabs;
